import { Row, Col } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";

import i18n from "i18next";
import {
  FooterSection,
  Title,
  Extra,
  LogoContainer,
  Para,
  Chat,
  FooterContainer,
  Language,
  Label,
  LanguageSwitch,
  LanguageSwitchContainer,
  NavLink,
} from "./styles";

const Footer = ({ t }: { t: TFunction }) => {
  const handleChange = (language: string) => {
    i18n.changeLanguage(language);
  };

  return (
    <>
      <FooterSection>
        <Container>
          <Row justify="space-between">
            <Col lg={8} md={8} sm={24} xs={24}>
              <Language>{t("Contact")}</Language>
              <Para>
                {t(`Do you have any question? Feel free to reach out.`)}
              </Para>
              <a href="mailto:fellowsheepstudios@gmail.com">
                <Chat>fellowsheepstudios@gmail.com</Chat>
              </a>
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              <Title>{t("Address")}</Title>
              <Para>FellowSheep Dance Studio</Para>
              <Para>Kraków</Para>
              <Para>Polska</Para>
            </Col>
            <Col lg={6} md={6} sm={12} xs={12}>
              <Label htmlFor="select-lang">{t("Language")}</Label>
              <LanguageSwitchContainer>
                <LanguageSwitch onClick={() => handleChange("pl")}>
                  <SvgIcon
                    src="poland.svg"
                    aria-label="Polski"
                    width="30px"
                    height="30px"
                  />
                </LanguageSwitch>
                <LanguageSwitch onClick={() => handleChange("en")}>
                  <SvgIcon
                    src="united-states.svg"
                    aria-label="English"
                    width="30px"
                    height="30px"
                  />
                </LanguageSwitch>
              </LanguageSwitchContainer>
            </Col>
          </Row>
        </Container>
      </FooterSection>
      <Extra>
        <Container border={true}>
          <Row
            justify="space-between"
            align="middle"
            style={{ paddingTop: "2rem" }}
          >
            <NavLink to="/">
              <LogoContainer>
                <SvgIcon
                  src="logo.svg"
                  aria-label="homepage"
                  width="200px"
                  height="80px"
                />
              </LogoContainer>
            </NavLink>
            <FooterContainer>
              <Para style={{ margin: 0, fontSize: "13px", opacity: 0.7, whiteSpace: "nowrap" }}>
                © {new Date().getFullYear()} FellowSheep Dance Studio ·{" "}
                <a
                  href={i18n.language === "en" ? "/privacy-en" : "/privacy"}
                  style={{ color: "inherit", textDecoration: "underline" }}
                >
                  {t("Polityka prywatności")}
                </a>
                {" · "}made by{" "}
                <a
                  href="https://fellowsheepstudios.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "inherit", textDecoration: "underline" }}
                >
                  FellowSheep Studios
                </a>
              </Para>
            </FooterContainer>
          </Row>
        </Container>
      </Extra>
    </>
  );
};

export default withTranslation()(Footer);
